var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Verifier',{ref:"verifier"}),_c('router-view',{on:{"dimissed":_vm.onDismissed}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }